import axios from 'axios';
import jwt from 'jsonwebtoken';

import appConfig from '../../app.config';

axios.interceptors.response.use(
  (response) => {
    return response ? response.data : null;
  },
  (error) => {
    if (
      error &&
      error.request &&
      error.request.responseType === 'blob' &&
      error.response.data instanceof Blob &&
      error.response.data.type &&
      error.response.data.type.toLowerCase().indexOf('json') !== -1
    ) {
      return new Promise((resolve, reject) => {
        let reader = new FileReader();
        reader.onload = () => {
          error.response.data = JSON.parse(reader.result);
          resolve(Promise.reject(error));
        };

        reader.onerror = () => {
          reject(error);
        };

        reader.readAsText(error.response.data);
      });
    }

    if (error && error.response && error.response.status === 401) {
      if (window.location.pathname !== '/anmelden') {
        localStorage.clear();
        window.location.replace('/');
      }
    }
    if (error && error.response && error.response.data) {
      if (error.response.data.error) {
        return Promise.reject(error.response.data.error);
      } else {
        return Promise.reject(error.response.data);
      }
    }

    return Promise.reject(error);
  }
);

axios.interceptors.request.use(async (config) => {
  config.headers['Content-Type'] = 'application/json';
  const authStr = localStorage.getItem('auth');
  const baseURL = localStorage.getItem('base-url');
  if (authStr && config.url.indexOf('base-url') === -1) {
    try {
      let auth = JSON.parse(authStr);
      if (new Date().getTime() > new Date(auth.expires_at).getTime() - 1000 * 60 * 60) {
        const refreshToken = await fetch(`${baseURL || ''}/api/v1/auth`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `${auth.token_type} ${auth.refresh_token}`,
          },
        });
        const body = await refreshToken.json();
        if (!body.access_token) {
          localStorage.clear();
          window.location.replace('/');
        } else {
          const expiresAt = new Date();
          expiresAt.setSeconds(expiresAt.getSeconds() + body.expires_in);
          body.expires_at = expiresAt;
          delete body.expires_in;

          const decodedAuth = jwt.decode(body.access_token);

          localStorage.setItem('auth', JSON.stringify({ ...body, role: decodedAuth.role, email: decodedAuth.email, username: decodedAuth.username }));
          auth = body;
        }
      }
      if (auth && auth.access_token) {
        config.headers['Authorization'] = `${auth.token_type} ${auth.access_token}`;
      }
    } catch (e) {
      console.log('Err parse auth', e);
    }
  }

  return config;
});

export const initBaseURL = async () => {
  try {
    localStorage.removeItem('base-url');
    const response = await axios({
      url: `${appConfig.enviromentServerUrl}/base-url`,
      timeout: appConfig.apiRequestTimeout,
    });

    axios.defaults.baseURL = response.url || appConfig.apiUrl;
    localStorage.setItem('base-url', axios.defaults.baseURL);
  } catch (err) {
    console.log('Get base url error - ', err);
    return null;
  }
};

axios.defaults.baseURL = appConfig.apiUrl || window.location.origin;
localStorage.setItem('base-url', axios.defaults.baseURL);

export default axios;
